import {ENTER_CHAR_CODE, MAX_TRIPBOARD_NAME_LENGTH} from '../../../utils/constants';
import {FormInput} from '@homeaway/react-form-components';
import React, {Component} from 'react';
import {withTranslationsAsProps} from '../../../components/translations';

export class EditName extends Component {
    static defaultProps = {
        boardId: null,
        altLabel: null,
        isMobile: false,
        label: '',
        name: '',
        onDone: () => {},
        onNameChange: () => {}
    }

    constructor(props) {
        super(props);

        this.state = {
            name: props.name
        };
    }

    handleInputKeyPress = (e) => {
        const {boardId, onDone} = this.props;
        const {name} = this.state;
        if (e.charCode === ENTER_CHAR_CODE) {
            onDone(boardId, name);
        }
    }

    handleNameChange = (e) => {
        const name = e.target.value;
        const isChanged = this.isNamedChanged(name);
        const isValid = this.isValidName(name);
        const {onNameChange} = this.props;
        this.setState({name});
        onNameChange({
            isNameChanged: isValid && isChanged,
            name: name.trim()
        });
    }

    isValidName = (name) => {
        name = name || this.state.name;
        const trimmed = name.trim();
        return trimmed.length > 0 && trimmed.length <= MAX_TRIPBOARD_NAME_LENGTH;
    }

    isNamedChanged = (name) => {
        return name.trim() !== this.props.name;
    }

    moveCursorToEnd = (e) => {
        const value = e.target.value;
        e.target.value = '';
        e.target.value = value;
    }

    render() {
        const {altLabel, isMobile, label} = this.props;
        const {name} = this.state;
        return (
            /* eslint-disable jsx-a11y/no-autofocus */
            <FormInput
                autoFocus={!isMobile}
                id="edit-name__id"
                onFocus={this.moveCursorToEnd}
                onKeyPress={this.handleInputKeyPress}
                className="trip-board-details__header-form-input"
                name="title"
                label={altLabel ? altLabel : label}
                value={name}
                maxLength={MAX_TRIPBOARD_NAME_LENGTH}
                onChange={this.handleNameChange}
                data-wdio="tripboard-details__edit-input"
            />
        );
    }
}

export default withTranslationsAsProps({
    'tripboards.modal.create.name': 'label'
})(EditName);



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/edit-name.js